import React, { useRef, useState } from 'react';

const FileTestPage = () => {
  const fileInputRef = useRef(null);
  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileChange = (e) => {
    console.log('🔍 FileTestPage - File changed!');
    console.log('🔍 Files:', e.target.files);
    if (e.target.files && e.target.files[0]) {
      console.log('✅ File selected:', e.target.files[0].name);
      setSelectedFile(e.target.files[0]);
    }
  };

  const handleButtonClick = () => {
    console.log('🔍 FileTestPage - Button clicked!');
    if (fileInputRef.current) {
      console.log('🔍 Triggering file input click...');
      fileInputRef.current.click();
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 p-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold mb-8">File Input Test Page</h1>
        
        <div className="space-y-8">
          {/* Test 1: Basic File Input */}
          <div className="bg-white p-6 rounded-lg shadow">
            <h2 className="text-xl font-semibold mb-4">Test 1: Basic File Input</h2>
            <input
              type="file"
              accept="image/*"
              onChange={handleFileChange}
              className="block w-full text-sm text-gray-500"
            />
            <p className="text-sm text-gray-600 mt-2">Click directly on this file input</p>
          </div>

          {/* Test 2: Button + Hidden Input */}
          <div className="bg-white p-6 rounded-lg shadow">
            <h2 className="text-xl font-semibold mb-4">Test 2: Button + Hidden Input</h2>
            <button
              onClick={handleButtonClick}
              className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
            >
              Click to Open File Chooser
            </button>
            <input
              ref={fileInputRef}
              type="file"
              accept="image/*"
              onChange={handleFileChange}
              style={{ display: 'none' }}
            />
            <p className="text-sm text-gray-600 mt-2">Click the button to trigger the hidden file input</p>
          </div>

          {/* Test 3: Styled File Input */}
          <div className="bg-white p-6 rounded-lg shadow">
            <h2 className="text-xl font-semibold mb-4">Test 3: Styled File Input</h2>
            <input
              type="file"
              accept="image/*"
              onChange={handleFileChange}
              className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
            />
            <p className="text-sm text-gray-600 mt-2">Click on this styled file input</p>
          </div>

          {/* Test 4: Multiple File Input */}
          <div className="bg-white p-6 rounded-lg shadow">
            <h2 className="text-xl font-semibold mb-4">Test 4: Multiple File Input</h2>
            <input
              type="file"
              accept="image/*"
              multiple
              onChange={handleFileChange}
              className="block w-full text-sm text-gray-500"
            />
            <p className="text-sm text-gray-600 mt-2">Click to select multiple files</p>
          </div>

          {/* Selected File Display */}
          {selectedFile && (
            <div className="bg-green-50 border border-green-200 rounded-lg p-4">
              <h3 className="font-semibold text-green-800 mb-2">Selected File:</h3>
              <p className="text-green-700">
                <strong>Name:</strong> {selectedFile.name}<br/>
                <strong>Size:</strong> {(selectedFile.size / 1024 / 1024).toFixed(2)} MB<br/>
                <strong>Type:</strong> {selectedFile.type}
              </p>
            </div>
          )}

          {/* Instructions */}
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
            <h3 className="font-semibold text-yellow-800 mb-2">Test Instructions:</h3>
            <ol className="list-decimal list-inside text-yellow-700 space-y-1">
              <li>Try clicking on each file input above</li>
              <li>Check if the file chooser dialog opens</li>
              <li>If it opens, try selecting a file</li>
              <li>Check the browser console for any error messages</li>
              <li>Report back which tests work and which don't</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FileTestPage;
